import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {

  // Using BehaviorSubject to manage a map of key-value pairs
  private dataSource = new BehaviorSubject<{ [key: string]: any }>(this.getDataFromStorage());
  currentData = this.dataSource.asObservable();

  constructor() {}

  // Method to change the state (add or update an entry in the BehaviorSubject)
  changeState(key: string, data: any) {
    const currentState = this.dataSource.getValue();
    currentState[key] = data;
    this.dataSource.next(currentState);
    this.setDataInStorage(currentState);  // Persist the data to session storage
  }

  // Method to retrieve a specific entry by key
  getState(key: string): any {
    return this.dataSource.getValue()[key] ?? null;
  }

  // Method to remove a specific entry by key
  removeState(key: string) {
    const currentState = this.dataSource.getValue();
    delete currentState[key];
    this.dataSource.next(currentState);
    this.setDataInStorage(currentState);
  }

  // Method to clear all data from the shared state and session storage
  clearAll() {
    this.dataSource.next({});
    sessionStorage.removeItem('sharedData');
  }

  // Retrieve the data from session storage
  private getDataFromStorage(): { [key: string]: any } {
    const jsonData = sessionStorage.getItem('sharedData');
    return jsonData ? JSON.parse(jsonData) : {};
  }

  // Set the data in session storage
  private setDataInStorage(data: { [key: string]: any }) {
    sessionStorage.setItem('sharedData', JSON.stringify(data));
  }
}
